import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import { Contrast } from "../../types/general.types";
import { hexToRgba } from "@icarros/utils-react";
const { color, opacity, size, text } = ids || {};
const defaultInputStyle = css `
  background: ${hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_empty)};
  border: ${size.border_width.ids_size_border_small} solid
    ${hexToRgba(color.border.ids_color_border_medium, opacity.ids_opacity_strong)};

  &:valid {
    border-color: ${color.border.ids_color_border_medium};
  }
  &:focus,
  &:active {
    outline-width: 0;
    border: ${size.border_width.ids_size_border_medium} solid
      ${color.action.primary.ids_color_action_primary_base};
  }
  &:disabled {
    border-color: ${color.border.ids_color_border_soft};
  }
`;
const onDarkInputStyle = css `
  background: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_empty)};
  border: ${size.border_width.ids_size_border_small} solid
    ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_strong)};
  &:focus,
  &:active {
    outline-width: 0;
    border: ${size.border_width.ids_size_border_medium} solid
      ${color.contrast.ids_color_contrast_onDark};
  }
  &:disabled {
    border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
  }
`;
export const PasswordCodeContainer = styled.div `
  display: flex;
  flex-direction: column;
  button {
    margin: 0 auto;
    padding: 0;
  }
`;
export const PasswordCodeTextContainer = styled.div `
  display: flex;
  align-items: center;
  gap: ${size.general.ids_size_general_8x};
`;
export const PasswordCodeInputsContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${size.general.ids_size_general_8x};
  padding: ${size.general.ids_size_general_8x} 0;
`;
export const PasswordCodeInputContainer = styled.div `
  position: relative;
  height: ${size.general.ids_size_general_48x};
  width: ${size.general.ids_size_general_32x};
  > * {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
export const PasswordCodeInput = styled.input `
  border-radius: ${size.corner_radius.ids_size_cornerRadius_password_code};
  height: ${size.general.ids_size_general_48x};
  width: ${size.general.ids_size_general_32x};
  text-align: center;
  box-shadow: none;
  caret-color: transparent;
  ${text.label.ids_textStyle_label_xlarge_regular};
  color: ${hexToRgba(color.action.neutral.ids_color_action_neutral_base, opacity.ids_opacity_empty)};
  ${({ show, contrast }) => {
    if (show) {
        return contrast === Contrast.dark
            ? `color: ${color.contrast.ids_color_contrast_onDark};`
            : `color: ${color.action.neutral.ids_color_action_neutral_base};`;
    }
}}
  ${({ contrast }) => contrast === Contrast.dark ? onDarkInputStyle : defaultInputStyle}
  ${({ error, contrast }) => {
    if (error) {
        return contrast === Contrast.dark
            ? `border: ${size.border_width.ids_size_border_medium} solid ${color.border.ids_color_border_strong};`
            : `border: ${size.border_width.ids_size_border_medium} solid ${color.border.ids_color_border_strong};`;
    }
}}
`;
//# sourceMappingURL=PasswordCode.style.js.map